<template>
  <div class="statistics-table">

    <el-row justify="space-between" class="total-statistics">
      <template v-for="(item, index) in totalColumns" :key="item.prop">
        <div class="total-item">
          <div class="item-title">{{item.label}}</div>
          <div>
            <span class="item-value">{{totalData[item.prop] || 0}}</span>
            <span class="item-sub-title">{{item.subLabel}}</span>
          </div>
        </div>
        <div><el-divider direction="vertical" v-if="index != totalColumns.length - 1"></el-divider></div>
      </template>
    </el-row>

    <el-table :data="idProvinceData" tooltip-effect="dark" border stripe height="545px">
      <el-table-column v-for="(column, index) in tableColumns" :key="index" :type="column.type" :prop="column.prop"
        :label="column.label" :width="column.width" :min-width="column.minWidth" :formatter="column.formatter"
        :fixed="column.fixed" :show-overflow-tooltip="column.tooltip">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    totalData: Object,
    idProvinceData: Array
  },
  data() {
    return {
      totalColumns: [
        { prop: 'totalNum', label: '发放人数', subLabel: '人次' },
        { prop: 'actualSalary', label: '累计发放', subLabel: '元' },
        { prop: 'avgSalary', label: '人均月薪', subLabel: '元' },
        { prop: 'maleAvgSalary', label: '男性人均月薪', subLabel: '元' },
        { prop: 'femaleAvgSalary', label: '女性人均月薪', subLabel: '元' }
      ],
      tableColumns: [
        { type: 'index', width: 90, label: '总额排名', formatter: (row, column, vlaue) => value + 1 },
        { prop: 'name', label: '省份', minWidth: 120, tooltip: true },
        { prop: 'actualSalary', label: '总额(元)', width: 110},
        { prop: 'avgSalary', label: '人均月薪(元)', width: 110 },
        { prop: 'maxSalary', label: '月薪最高(元)', width: 110 }
      ]
    };
  }
})
</script>

<style lang="scss" scoped>
.statistics-table {
  width: 49%;
  .total-statistics {
    border: 1px solid #02a7f0;
    padding: 15px;
    text-align: center;
    flex-wrap: nowrap;
    align-items: stretch;
    margin-bottom: 15px;
    .total-item {
      .item-title {
        color: #409eff;
        font-size: 16px;
        margin-bottom: 5px;
      }
      .item-value {
        font-size: 20px;
        color: #409eff;
        font-weight: bold;
      }
      .item-sub-title {
        color: #409eff;
        font-size: 13px;
      }
    }
    .el-divider {
      height: 100%;
      border-color: #409eff;
    }
  }
}
</style>